<template>
  <div class="page">
    <div class="container">
        <div id="page-inicio">
            
            <div class="columns">
                <div class="column">
                    <h4 class="title is-size-5">Eventos</h4>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <a href="/p/curso/37" class="course-featured"><img class="img-responsive" src="/img/encontro1.jpeg" ></a>
                </div>
                <div class="column">
                    <a href="/p/curso/36" class="course-featured"><img class="img-responsive" src="/img/candango.jpeg" ></a>
                </div>
            </div>
            <div class="columns">
              <div class="column">
                <div class="slogan">Um espaço potencial para a construção de diversas formas do brincar criativo</div>
              </div>
            </div>
            <div class="columns">
                <div class="column"></div>
                <div class="column">
                    <a href="/cursos">
                        <div class="flip-container" style="height:220px">
                            <div class="flipper">
                                <div class="front cursos" style="height:220px"><img class="image_apres img-responsive" src="/img/cursos_extensao.jpg" style="height:220px">
                                    <div class="titulo">Extensão</div>
                                </div>
                                <div class="back cursos" style="height:220px">
                                    <div class="texto-verso">Cursos de Extensão</div>
                                </div>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="column">
                    <a href="/grupo-de-estudos">
                        <div class="flip-container" style="height:220px">
                            <div class="flipper">
                                <div class="front grupos" style="height:220px"><img class="image_apres img-responsive" src="/img/grupos_estudo.jpg" style="height:220px">
                                    <div class="titulo">Estudo</div>
                                </div>
                                <div class="back grupos" style="height:220px">
                                    <div class="texto-verso">Grupo de Estudo</div>
                                </div>
                            </div>
                        </div>
                    </a>
                </div>
                 <div class="column"></div>
            </div>
            <div class="columns">
              <div class="column">
                <h4 class="title is-size-5">Cursos | Inscrições</h4>
              </div>
            </div>
            <div class="columns">
              <div class="column"  >
                <div class="container-cursos" :style='`max-width: ${cursos.length*420}px`'>
                  <div class="curso" v-for="(o, index) in cursos" :key="o.id">
                    <span><b>até {{formatFim(o.inscricoes_fim)}}</b></span>
                    <div v-if='o.imagem_original'  :style='`background-image: url(http://www.espacowinnicottbsb.com.br${o.imagem_thumb}); background-repeat: no-repeat;background-size:cover; height:200px; width: 100%`' class="image"></div>
                     <img v-else src="/img/no_image.png" class="image">
                    <div style="padding: 14px;">
                      
                      <b style="font-size:15px" v-html='o.titulo'> </b>
                      <div style="font-size:14px" v-html='o.resumo'> </div>
                      <div class="bottom clearfix">
                        <br />
                        <el-button type="default" size="small" @click='$router.push(`/p/curso/${o.id}`)' >Detalhes</el-button>
                        <el-button type="primary" size="small" @click='$router.push(`/p/curso/${o.id}/inscricao`)'>Inscrever-se</el-button>
                      </div>
                    </div>
                  </div>
                  <div class="is-clearfix"></div>
                </div>
            </div>
          </div>
          
            

        </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';

export default {
  name: 'Index',
  components:{
  },
  props: {
    msg: String
  },
  data() {
      return {
        currentDate: '',
        cursos: []
        }
  },
  methods:{
    handleClick() {
        console.log('click');
    },
    getCursos(){
      axios.get(`${global.base}/api/cursos`,{
        }).then((r)=>{
          const data = r.data.map(x=>{ 
            x.unix = moment(x.data).unix(); 
            return x 
          } )
          let data1 = data.sort((a,b) => {
            return a.unix - b.unix;
          })
          this.cursos = data1;
        }).catch(()=>{
        })
    },
    formatFim(f){
      return moment(f, "%Y-%MM-%DD").format("DD [de] MMMM [de] YYYY");
    }
  },
  mounted(){
    this.getCursos();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .course-featured{
    border: 1px solid #00000055;
    padding:2px;
    display: block;
  }
  .course-featured:hover{
    border: 1px solid #532703f6;
  }
  .container-cursos{
    margin: auto;
  }
  .curso{
    margin:auto;
    width: 400px;
    border: 1px solid #C0C0C0;
    padding: 20px;
    margin: 10px;
    float:left;
    border-radius:5px;
  }
  .slogan{
    font-family: 'Handlee', cursive;
    font-size: 25px;
  }

</style>
